import { createContext } from 'react'
import type { AppLocale } from '../../../supabase/functions/_shared/app-locale'

export type Locale = AppLocale
export type { AppLocale }

export type I18nContextValue = {
  locale: Locale
  setLocale: (locale: Locale) => void
  t: (text: string) => string
}

export const I18nContext = createContext<I18nContextValue | null>(null)
